module.exports = "<app-bod-info bodId=\"673\"></app-bod-info>\n<app-shareholder-google></app-shareholder-google>"


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/bod/bod-screen/bod-screen.component.html
// module id = ../../../../../src/app/securities-level/bod/bod-screen/bod-screen.component.html
// module chunks = main